import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export type OttopilotEventContainerConstraint =
    | {
          duration: string;
          isAdditionalColumn: boolean;
          refColumnId: Uuid | string;
          type: "Time";
      }
    | {
          columnType: "OttopilotEvent" | "OttopilotEventContainer";
          disallowedStatuses: Array<Uuid>;
          isAdditionalColumn: boolean;
          refColumnId: Uuid | string;
          type: "Status";
      };

export const ottopilotEventContainerConstraintValidator: zod.ZodType<OttopilotEventContainerConstraint> =
    zod.discriminatedUnion("type", [
        zod.strictObject({
            type: zod.literal("Time"),
            refColumnId: zod.string(),
            isAdditionalColumn: zod.boolean(),
            duration: zod.string(),
        }),
        zod.strictObject({
            type: zod.literal("Status"),
            columnType: zod.enum(["OttopilotEvent", "OttopilotEventContainer"]),
            refColumnId: zod.string(),
            isAdditionalColumn: zod.boolean(),
            disallowedStatuses: uuidZodValidator.array(),
        }),
    ]);
